module.exports = __webpack_public_path__ + "img/score_7.e40d3fa1.png";